import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
const CASE_STUDIES = [{
  slug: 'omnicredit',
  client: 'Omnicredit',
  title: 'From Zero to $40K/Month in Just 4 Months',
  description: 'How we built a complete acquisition system from scratch for an early-stage financial brand—going from zero infrastructure to $40K/month in just four months.',
  tags: ['Lead Gen', 'Paid Social', 'Financial Services']
}, {
  slug: 'christmas-palace',
  client: 'The Christmas Palace',
  title: 'Turning Content into Holiday Demand at Scale',
  description: 'How we built a content-first growth engine that generated 8M+ views in 90 days, turning social content into real-world holiday demand and foot traffic.',
  tags: ['E-Commerce Growth', 'Multi-Channel Scaling']
}, {
  slug: 'levelup-insurance',
  client: 'Levelup Insurance',
  title: 'Scaling High-Quality Leads Nationwide',
  description: 'How we built a bilingual lead acquisition system that scaled from $3K to $70K/month in ad spend—while improving lead quality and expanding nationwide.',
  tags: ['Scaling', 'Paid Search']
}, {
  slug: 'z-roofing',
  client: 'Z Roofing and Waterproofing',
  title: 'From Invisible to Trusted: Building a Local Authority Brand',
  description: "How we transformed a local roofing company's digital presence into a trust-building asset—aligning their online image with the quality of their work.",
  tags: ['Local Service', 'Brand Authority']
}, {
  slug: 'the-christmas-palace-2',
  client: 'The Christmas Palace',
  title: 'How we grew a milllion dollar business online store 56% in one season',
  description: 'How we engineered a performance-driven ecosystem that turned a discount-dependent seasonal brand into a year-round growth machine with +56% net sales and +1,919% SMS growth.',
  tags: ['The Engage Machine', 'Paid Media', 'Website CRO']
}, {
  slug: 'watch-me-grow',
  client: 'Watch Me Grow Learning Center',
  title: 'Turning Demand Into Enrollments in Just 90 Days',
  description: 'How we deployed a focused enrollment system that generated 67 new student enrollments in just 90 days—turning inconsistent demand into a predictable growth engine.',
  tags: ['Lead Generation', 'Education Marketing', 'Paid Ads']
}];
export function CaseStudies() {
  return <div className="w-full pt-20" data-id="element-639">
      {/* Hero */}
      <section className="py-24 md:py-40 bg-engage-black text-center px-4 md:pt-[240px] md:pb-[240px]" data-id="element-640">
        <div className="max-w-4xl mx-auto" data-id="element-641">
          <h1 className="text-3xl md:text-7xl font-black text-engage-white mb-6 tracking-tight text-balance" data-id="element-642">
            Growth Stories Built With The Engage Machine
          </h1>
          <p className="text-base md:text-2xl font-bold text-engage-yellow tracking-wide" data-id="element-643">
            Real brands. Real challenges. Real results.
          </p>
        </div>
      </section>

      {/* Intro */}
      <section className="py-24 md:py-32 bg-engage-gray1 border-y border-engage-gray2" data-id="element-644">
        <div className="max-w-6xl mx-auto px-4" data-id="element-645">
          <div className="text-center" data-id="element-646">
            <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-647">
              How We Create These Results
            </h2>
            <p className="text-lg md:text-xl text-engage-gray4 leading-relaxed max-w-3xl mx-auto" data-id="element-648">
              Every brand is different, but the mechanics of growth are
              universal. We don't rely on hacks or temporary trends. We build
              robust, data-driven systems that consistently acquire customers at
              a profit. Here's how we've done it for others.
            </p>
          </div>
        </div>
      </section>

      {/* Grid */}
      <section className="py-24 bg-engage-black" data-id="element-649">
        <div className="max-w-7xl mx-auto px-4" data-id="element-650">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-651">
            {CASE_STUDIES.map(study => <Card key={study.slug} accent className="flex flex-col h-full group" data-id="element-652">
                <div className="flex-grow" data-id="element-653">
                  <div className="flex flex-wrap gap-2 mb-6" data-id="element-654">
                    {study.tags.map(tag => <span key={tag} className="px-3 py-1 bg-engage-gray2 text-engage-gray5 text-xs font-semibold uppercase tracking-wider rounded-full" data-id="element-655">
                        {tag}
                      </span>)}
                  </div>
                  <span className="text-engage-yellow font-bold text-sm uppercase tracking-wider mb-2 block" data-id="element-656">
                    {study.client}
                  </span>
                  <h3 className="text-3xl font-bold mb-4 group-hover:text-engage-yellow transition-colors" data-id="element-657">
                    {study.title}
                  </h3>
                  <p className="text-engage-gray4 text-lg mb-8" data-id="element-658">
                    {study.description}
                  </p>
                </div>
                <Link to={`/case-studies/${study.slug}`} className="inline-flex items-center gap-2 text-engage-gray4 font-semibold mt-auto group-hover:text-engage-yellow transition-colors duration-300" data-id="element-659">
                  <span data-id="element-660">View Case Study</span>
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform duration-300" data-id="element-661" />
                </Link>
              </Card>)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-engage-gray1 border-t border-engage-gray2 text-center px-4" data-id="element-662">
        <div className="max-w-3xl mx-auto" data-id="element-663">
          <h2 className="text-4xl font-bold mb-6" data-id="element-664">
            Ready to be our next success story?
          </h2>
          <Button to="/contact" variant="primary" className="text-lg px-10 py-4" data-id="element-665">
            Book a Call With Us
          </Button>
        </div>
      </section>
    </div>;
}